<!-- 待评论列表-->
<template>
  <div>
    <van-cell  v-for="val in stay_list" :key="val.id" :title="val.title" :label="val.sub_title"  :value="val.desc" @click="show=true">
    <template #right-icon>
      <van-tag type="warning">去评价</van-tag>
    </template>
    </van-cell>
    <!-- 评价功能 -->
    <van-popup v-model="show" position="right" >
      <v-touch class="popup_body" @swiperight="show = false" >
        <comments/>
      </v-touch>
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
.van-cell__value {
  top: 10px;
}
.van-icon-arrow::before {
  position: relative;
  top: 10px;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-tag--warning {
  text-align: center;
  width: 30px;
  height: 20px;
  margin-top: 10px;
  margin-left: 8px;
}
</style>

<script>
import comments from '../stay/comments'
export default {
  name: 'stay_list',
  components: {comments},
  data () {
    return {
      show: false,
      stay_list: [
        {
          id: 1,
          title: '贝林展厅',
          sub_title: '2019-08-25 10:00:37',
          desc: '在线加油 5L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        },
        {
          id: 2,
          title: '测试站点01',
          sub_title: '2019-09-01 15:00:59',
          desc: '在线加油 70L'
        }
      ],
      data: []
    }
  },
  created () {
    this.get_data()
  },
  methods: {
    // 获取数据
    get_data () {
      this.get_site_data(this, true, (res) => {
        this.data = res
        this.$root.loadingAll = false
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/stay/stay_list.vue